import { render } from "./AccordionGroup.vue?vue&type=template&id=6cd03d2e"
import script from "./AccordionGroup.vue?vue&type=script&lang=js"
export * from "./AccordionGroup.vue?vue&type=script&lang=js"

import "./AccordionGroup.vue?vue&type=style&index=0&id=6cd03d2e&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__